
<script>
import axios from 'axios';
import { Bar } from 'vue-chartjs'

export default {
    extends: Bar,
    props: ['req'],
    data() {
        return {
            info: null,
            opts: {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    yAxes: [
                        {
                            stacked: false
                        }
                    ]
                }
            }
        };
    },
    mounted () {
        axios
            .get('http://magnum-dev.presstoday.com/'+this.req)
            .then(response => {
                this.info = response.data.data
                //console.log(response.data.data);
                this.renderChart(this.info, this.opts);
            }
        )
    }
}
</script>